import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import LassoGrid from "../../components/LassoGrid";
import { useGetApprovedUsersQuery } from "../../api/approvedUsersApiSlice";
import { ApprovedUsersColumnDefinitions } from "./ApprovedUsersColumnDefinitions";
import ApprovedUserDetails from "./components/ApprovedUserDetails";

const ApprovedUsers = () => {
    const [selectedRow, setSelectedRow] = useState<Record<string, any>>({});
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const { data: approvedUsers } = useGetApprovedUsersQuery({});

    const handleRowClick = (event: any) => {
        setSelectedRow(event.data);
        setIsDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false);
    };

    return (
        <Stack height="100%" gap={3}>
            <Typography variant="h4">
                Approved User List
            </Typography>
            <ApprovedUserDetails
                selectedUser={selectedRow}
                isDrawerOpen={isDrawerOpen}
                handleCloseDrawer={handleCloseDrawer}
            />
            <LassoGrid
                columns={ApprovedUsersColumnDefinitions}
                defaultColDef={{ filter: true, suppressAutoSize: false, resizable: true }}
                data={approvedUsers}
                idKey={"rowId"}
                searchable={true}
                tab={""}
                showHide={[]}
                onRowClicked={handleRowClick}
                cursorHoverOption="pointer"
            />
        </Stack>
    );
}

export default ApprovedUsers;
